import type { SpriteDefinition } from '@/render/spriteBaker';
import { PALETTE } from '@/sprites/palette';

/**
 * A dropped pile, 16x16 to sit on the tile grid like everything else.
 *
 * One shape for every item rather than art per item: the sprite says "something
 * is here", and the tint says which something — the same trick the slots use.
 * Per-item ground art would be ninety sprites to maintain for a thing the
 * player looks at for two seconds on the way to picking it up.
 *
 * Drawn as a small sack so it reads as dropped rather than growing.
 */
export const GROUND_ITEM_SPRITE: SpriteDefinition = {
  name: 'ground-item',
  rows: [
    '................',
    '................',
    '................',
    '................',
    '................',
    '................',
    '.......ww.......',
    '......wmmw......',
    '.....wmmmmw.....',
    '....wmmmmmmw....',
    '....wmmmmmmw....',
    '....wmmmmmmw....',
    '.....wmmmmw.....',
    '......wwww......',
    '................',
    '................',
  ],
  palette: PALETTE,
};
